export default {
  methods: {
    /**
     * 根据组件名像上查找父组件,  只返回最近的一个
     * @param compName 组件名
     */
    getParent (compName) {
      let parent = this.$parent
      while (parent) {
        if (parent.$options.compName === compName) {
          return parent
        } else {
          parent = parent.$parent
        }
      }
      return null
    },
    /**
     * 根据组件名查询子元素, 返回所有找到的子元素
     * @param compName
     */
    getChildren (compName) {
      const children = []
      function dg (arr) {
        if (!arr) return
        arr.forEach(elm => {
          dg(elm.$children)
          if (elm.$options.compName === compName) children.push(elm)
        })
      }
      dg(this.$children)
      return children
    }
  }
}



// WEBPACK FOOTER //
// ./src/packages/mixin/findNode.js